var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-btns-actions-report-all"},[_c('div',{staticClass:"content-btn-generate-report"},[_c('v-btn',{staticClass:"global-btn-primary",on:{"click":_vm.setDialogGenerateReport}},[_vm._v(" Generar reporte ")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }